module.exports = __webpack_public_path__ + "img/box1-r.c68ecd0b.png";